import React from 'react';
import IframeComm from 'react-iframe-comm';
import { compose } from 'recompose';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { commonStyles } from '../../styles/styles';

const LearnerThinkToolView = ({ classes, pathForIFrame, onReceiveMessage }) => {
  const attributes = {
    src: pathForIFrame+'&coach=true',
    width: '100%',
    height: '100%',
  };
  return (
    <div style={{position:'absolute', top:0, left:0, right:0, bottom:0, zIndex:10000}}>
      <div className={classes.thinkTool}>
        {pathForIFrame && (
          <IframeComm attributes={attributes} handleReceiveMessage={onReceiveMessage} />
        )}
      </div>
    </div>
  );
};

LearnerThinkToolView.propTypes = {
  classes: PropTypes.instanceOf(Object),
  pathForIFrame: PropTypes.string,
  onReceiveMessage: PropTypes.func,
};

const styles = () => ({
  ...commonStyles,
});

export default compose(withStyles(styles))(LearnerThinkToolView);



// WEBPACK FOOTER //
// ./src/Screens/Components/LearnerThinkToolView.jsx